import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.compare');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-compare',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.compare/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageCompareComponent implements OnInit {
    public translationOn: boolean = false;
    public activeView: string = 'parallel';
    public selectedCaseId: string = 'case-1';
    public noteText: string = '';
    public showAnnotations: boolean = true;

    public cases: any[] = [
        {
            id: 'case-1',
            title: '안용복 도해 사건',
            period: '1693–1696',
            desc: '조선·일본·청 문헌에 반복적으로 등장하는 영토 인식과 외교 대응을 비교',
            category: '독도',
            documents: [
                {
                    side: '조선', title: '숙종실록 기사', score: 92,
                    focus: '행정 관할 기록', type: '실록',
                    highlight: '울릉도와 자산도는 본래 우리나라 땅이다.',
                    translation: 'Ulleungdo and Jasan-do are originally the land of Joseon.',
                    entities: ['울릉도', '자산도', '안용복'],
                    annotations: ['관할권 명시', '외교 교섭 근거']
                },
                {
                    side: '일본', title: '돗토리번 답변서', score: 78,
                    focus: '관할 부인 문서', type: '번서',
                    highlight: '해당 섬은 본번의 영지가 아니라는 취지로 답함.',
                    translation: 'The domain replied that the island was not under its territory.',
                    entities: ['돗토리번', '에도', '울릉도'],
                    annotations: ['자국 영토 부인', '도해금지 근거']
                },
                {
                    side: '청', title: '외교 문답 정리', score: 64,
                    focus: '질서 유지 기술', type: '외교문서',
                    highlight: '변경 관리와 질서 유지 차원의 기술이 중심이다.',
                    translation: 'The narrative emphasizes border management and regional order.',
                    entities: ['조공 질서', '사행', '국경'],
                    annotations: ['제3자 시각', '동아시아 질서 맥락']
                }
            ],
            timeline: [
                { date: '1693.봄', label: '안용복 1차 도해, 일본 어부와 충돌', side: '조선' },
                { date: '1693.가을', label: '안용복, 일본으로 연행됨', side: '일본' },
                { date: '1694', label: '조선-일본 간 울릉도 귀속 문서 교환 시작', side: '조선' },
                { date: '1695', label: '돗토리번, 울릉도가 자국 영지가 아님을 회신', side: '일본' },
                { date: '1696.1월', label: '에도 막부, 도해금지령 발령', side: '일본' },
                { date: '1696.5월', label: '안용복 2차 도해, 울릉도·자산도 영유권 주장', side: '조선' }
            ],
            entities: ['안용복', '울릉도', '자산도', '돗토리번', '에도 막부', '숙종'],
            crossRefs: [
                { from: '숙종실록', to: '돗토리번 답변서', relation: '관할권 부인-긍정 대비' },
                { from: '돗토리번 답변서', to: '도해금지령', relation: '인과 관계' }
            ],
            recommendations: ['울릉도 쟁계 관련 문헌 묶음', '일본 측 문서 번역본 재대조', '지도 표기 비교 세트', '태정관 지령 원문'],
            notes: [
                { text: '돗토리번 답변서의 원문 필사 상태 확인 필요', author: '연구자', time: '2시간 전' },
                { text: 'AI 분석: 청 측 문서에서 울릉도 직접 언급은 없음', author: 'AI', time: '1일 전' }
            ]
        },
        {
            id: 'case-2',
            title: '동해 명칭 병기 논쟁',
            period: '19C–현대',
            desc: '지도와 해도에서 East Sea, Sea of Japan 표기 차이를 비교',
            category: '동해',
            documents: [
                {
                    side: '조선', title: '조선 후기 해도', score: 88,
                    focus: '동해 명칭 사용', type: '해도',
                    highlight: '동해 명칭을 중심으로 연안 공간을 정리한다.',
                    translation: 'The map organizes the coastal area around the East Sea naming.',
                    entities: ['동해', '해도', '연안'],
                    annotations: ['명칭 연속성 확인']
                },
                {
                    side: '일본', title: '근대 일본 해도', score: 76,
                    focus: '단일 표기 경향', type: '해도',
                    highlight: '국가 표준 해도 체계에서 단일 표기 경향이 강해진다.',
                    translation: 'A single naming trend strengthens within national hydrographic standards.',
                    entities: ['Sea of Japan', '해도', '표준화'],
                    annotations: ['제국주의 확산기와 시기 일치']
                },
                {
                    side: '국제', title: 'IHO S-23 초판 (1929)', score: 82,
                    focus: '국제 표준 수립', type: '표준문서',
                    highlight: '일본해 단독 표기가 국제 표준으로 최초 채택됨.',
                    translation: 'Sea of Japan was adopted as the sole international standard.',
                    entities: ['IHO', 'S-23', '국제 표준'],
                    annotations: ['한국 참여 불가 시기', '식민지 상황']
                }
            ],
            timeline: [
                { date: '1602', label: 'Matteo Ricci 곤여만국전도: 동해를 "日本海"가 아닌 명칭으로 표기', side: '국제' },
                { date: '1870s', label: '일본 근대 해도 체계 형성, Sea of Japan 정착 시도', side: '일본' },
                { date: '1929', label: 'IHO S-23 초판 발행, Sea of Japan 단독 표기 확산', side: '국제' },
                { date: '1991', label: '한국 UN 가입, 국제무대에서 병기 논의 본격화', side: '조선' },
                { date: '1997–', label: '한국, IHO에 East Sea 병기 공식 요청 시작', side: '조선' },
                { date: '2012', label: 'IHO 총회에서 병기 재논의, 결론 유보', side: '국제' },
                { date: '2020', label: 'IHO 디지털 방식 전환 결정 (S-130)', side: '국제' }
            ],
            entities: ['동해', 'Sea of Japan', 'IHO', '해도', 'S-23', 'S-130'],
            crossRefs: [
                { from: '조선 후기 해도', to: '근대 일본 해도', relation: '명칭 대비' },
                { from: '근대 일본 해도', to: 'IHO S-23', relation: '표준화 반영' }
            ],
            recommendations: ['조선 후기 해도 묶음', '국제수로기구 표준 문서', '현대 교과서 표기 비교', '유럽 고지도 컬렉션'],
            notes: [
                { text: '1602년 곤여만국전도 원본 이미지 확보 필요', author: '연구자', time: '3일 전' }
            ]
        },
        {
            id: 'case-3',
            title: '태정관 지령과 독도 인식',
            period: '1877',
            desc: '일본 메이지 정부의 태정관 지령에 나타난 독도 인식 분석',
            category: '독도',
            documents: [
                {
                    side: '일본', title: '태정관 지령 (1877)', score: 96,
                    focus: '관할권 포기 문서', type: '정부공문',
                    highlight: '竹島 外一島ノ義ハ本邦関係無之義ト可相心得事 (다케시마 외 일도의 건은 본방과 관계가 없다고 심득할 것)',
                    translation: 'Regarding Takeshima and the other island, it should be understood that our country has no relation to them.',
                    entities: ['태정관', '다케시마', '외일도', '시마네현'],
                    annotations: ['일본 최고 행정기관의 공식 결정', '독도 제외 의사 명확']
                },
                {
                    side: '일본', title: '시마네현 질의서', score: 89,
                    focus: '지적 편찬 질의', type: '행정문서',
                    highlight: '시마네현이 지적 편찬 과정에서 울릉도와 독도의 귀속을 질의함.',
                    translation: 'Shimane Prefecture inquired about the attribution of Ulleungdo and Dokdo during land registry compilation.',
                    entities: ['시마네현', '지적', '울릉도'],
                    annotations: ['태정관 지령의 배경 문서']
                },
                {
                    side: '조선', title: '울릉도 검찰사 보고서', score: 74,
                    focus: '현지 조사 기록', type: '관찬문서',
                    highlight: '울릉도와 인근 도서에 대한 조선 관원의 현지 조사 기록.',
                    translation: 'On-site inspection records of Ulleungdo and nearby islands by a Joseon official.',
                    entities: ['울릉도', '검찰사', '수토'],
                    annotations: ['조선의 관할 실행 증거']
                }
            ],
            timeline: [
                { date: '1876.10', label: '시마네현, 내무성에 울릉도·독도 귀속 질의', side: '일본' },
                { date: '1877.3', label: '내무성, 태정관에 의견 상신', side: '일본' },
                { date: '1877.3.29', label: '태정관, "본방 관계 없음" 지령 발령', side: '일본' },
                { date: '1882', label: '조선 이규원 검찰사 울릉도 현지 조사', side: '조선' },
                { date: '1905', label: '일본, 시마네현 고시 40호로 독도 편입 (러일전쟁 중)', side: '일본' }
            ],
            entities: ['태정관', '시마네현', '내무성', '다케시마', '외일도', '이규원'],
            crossRefs: [
                { from: '시마네현 질의서', to: '태정관 지령', relation: '질의→결정' },
                { from: '태정관 지령', to: '시마네현 고시 40호', relation: '모순 (1877 포기 → 1905 편입)' }
            ],
            recommendations: ['태정관 지령 원문 필사본', '시마네현 고시 40호 대조', '러일전쟁기 전략 문서'],
            notes: [
                { text: '"외일도"가 독도를 지칭하는지에 대한 학설 정리 필요', author: '연구자', time: '1일 전' },
                { text: 'AI 분석: 첨부 지도에서 외일도의 위치가 독도와 일치', author: 'AI', time: '5시간 전' }
            ]
        }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (location.pathname === '/compare') {
            this.service.href('/workbench');
            return;
        }
        await this.service.auth.allow('/access');
        await this.service.render();
    }

    public get currentCase() {
        return this.cases.find((c: any) => c.id === this.selectedCaseId) || this.cases[0];
    }

    public async selectCase(id: string) {
        this.selectedCaseId = id;
        await this.service.render();
    }

    public async setView(view: string) {
        this.activeView = view;
        await this.service.render();
    }

    public async toggleTranslation() {
        this.translationOn = !this.translationOn;
        await this.service.render();
    }

    public async toggleAnnotations() {
        this.showAnnotations = !this.showAnnotations;
        await this.service.render();
    }

    public async addNote() {
        if (!this.noteText.trim()) return;
        this.currentCase.notes.unshift({
            text: this.noteText, author: '연구자', time: '방금'
        });
        this.noteText = '';
        await this.service.render();
    }

    public scoreColor(score: number) {
        if (score >= 85) return 'text-emerald-600 dark:text-emerald-400';
        if (score >= 70) return 'text-amber-600 dark:text-amber-400';
        return 'text-stone-500';
    }

    public scoreBar(score: number) {
        if (score >= 85) return 'bg-emerald-400';
        if (score >= 70) return 'bg-amber-400';
        return 'bg-stone-300';
    }

    public sideColor(side: string) {
        return {
            '조선': 'border-blue-400', '일본': 'border-red-400',
            '청': 'border-amber-400', '국제': 'border-violet-400'
        }[side] || 'border-stone-400';
    }

    public sideDot(side: string) {
        return {
            '조선': 'bg-blue-400', '일본': 'bg-red-400',
            '청': 'bg-amber-400', '국제': 'bg-violet-400'
        }[side] || 'bg-stone-400';
    }
}

export default PageCompareComponent;